import React from 'react'
import { Modal, Row, Space } from 'antd'
import { ButtonEx } from '../../HeroLocations/index.style'

const LocationDelete = (props) => {
  const { visible, onCancel, onOk } = props
  return (
    <Modal
      title="ยืนยัน"
      visible={visible}
      onCancel={onCancel}
      onOk={onOk}
      footer={null}>
      <p>คุณยืนยันจะลบสถานที่ของคุณ ?</p>
      <p style={{ color: 'red' }}>
        การลบข้อมูลสถานที่จะทำให้ข้อมูลการทิ้งสูญหาย
      </p>
      <Row justify="end">
        <Space>
          <ButtonEx onClick={() => onCancel()}>ยกเลิก</ButtonEx>
          <ButtonEx color="#6ebf4b" type="primary" onClick={() => onOk()}>
            ยืนยัน
          </ButtonEx>
        </Space>
      </Row>
    </Modal>
  )
}

export default LocationDelete



// WEBPACK FOOTER //
// ./src/pages/AccountLocationBin/LocationDelete/index.js